module.exports = __webpack_public_path__ + "img/bdshzb-detail.b52f1d97.png";